export class FunctionProfileStruct {
    public idProfile: number;
    public function: string;
    public idInternalReportFunctionProfile: number;
}
